import { environment } from '../../../environments/environment';

/**
 * Language Configuration Types
 * Based on environment configuration
 */

// Extract supported languages from environment
export type SupportedLanguage = typeof environment.supportedLanguages[number];

// Language code type (for compatibility)
export type LanguageCode = SupportedLanguage;

// Language names mapping
export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  'en': 'English',
  'uk': 'Українська',
  'lv': 'Latviešu'
} as const;

// Helper functions
export function getDefaultLanguage(): SupportedLanguage {
  return environment.defaultLanguage as SupportedLanguage;
}

export function getSupportedLanguages(): SupportedLanguage[] {
  return environment.supportedLanguages as SupportedLanguage[];
}

export function isLanguageSupported(lang: string): lang is SupportedLanguage {
  return environment.supportedLanguages.includes(lang as SupportedLanguage);
}

export function getLanguageWithFallback(lang?: string | null): SupportedLanguage {
  if (!lang) {
    return getDefaultLanguage();
  }
  
  if (isLanguageSupported(lang)) {
    return lang;
  }
  
  return getDefaultLanguage();
}